import { EdisuRoutesPath } from 'interfaces/'
import { ExtractRouteParams, generatePath } from 'react-router'

function generateRoutePath<S extends string>(routeName: EdisuRoutesPath, params?: ExtractRouteParams<S>) {
  return generatePath(routeName, params)
}

export const routeService = {
  generateRoutePath,
}
